module.exports = __webpack_public_path__ + "static/media/15.76eec64b.png";